import {getClientConfig} from 'ultra/configs/general';

import {get} from '../../../Helpers/http';

const {api} = getClientConfig(window)

export function getLibrary(city, search) {
    let link = `${api}/library/${city}/utils/list`;
    if (search) link += search
    return get(link);
}
